// extracted by mini-css-extract-plugin
export default {"coursesBy":"styles_coursesBy__j26Dm","thinner":"styles_thinner__9x+Ui","subHeading":"styles_subHeading__X+mMI","cbList":"styles_cbList__bcN7J"};